import Acompanhamento from "@pages/Acompanhamento/Acompanhamento";

export default Acompanhamento;
